"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./Engine/XDB/XDB"), exports);
__exportStar(require("./XEvent"), exports);
require("../../Static/css/reset-min.css");
require("../../Static/css/fonts-min.css");
require("../../Static/css/alert-box.css");
require("../../Static/css/base.css");
require("../../Static/css/city.css");
require("../../Static/css/world.css");
require("../../Static/css/lastStyle.css");
require("../../Static/css/lastOfLast.css");
require("../../Static/css/finishing.css");
require("../../Static/css/tooltips.css");
require("../../Static/css/animation.css");
require("../../Static/css/hero.css");
require("../../Static/css/godPoints.css");
require("../../Static/css/ui.css");
require("../../Static/css/team.css");
